import { ArticleCard } from './article-card'
import type { ArticlePreview } from '@/lib/article-previews'

/** Data adapter only: all article-list presentation stays in ArticleCard. */
export function ArticlePreviewCard({ article }: { article: ArticlePreview }) {
  return <ArticleCard
    href={`/blogs/news/${article.slug}`}
    title={article.title}
    imageUrl={article.image || undefined}
    author={article.authorName || undefined}
    authorImageUrl={article.authorImageUrl}
    date={article.publishedAt || undefined}
    excerpt={article.excerpt}
    badge="News"
    className="h-full"
  />
}
